<template>
  <section class="wiki-search">
    <label :for="inputId">Buscar en los instructivos</label>
    <div class="wiki-search-row">
      <input :id="inputId" v-model.trim="query" type="search" placeholder="Ej.: coordenadas, filtros, imprimir…" @input="schedule" @keyup.enter="run" />
      <button class="btn btn-primary" :disabled="query.length < 2 || loading" @click="run">Buscar</button>
    </div>
    <p v-if="loading" class="wiki-muted">Buscando…</p>
    <p v-else-if="error" class="wiki-error">{{ error }}</p>
    <p v-else-if="searched && !results.length" class="wiki-muted">No se encontraron resultados.</p>
    <ul v-if="results.length" class="wiki-results">
      <li v-for="result in results" :key="result.article_slug + result.anchor">
        <router-link :to="resultLink(result)">
          <strong>{{ result.article_title }}</strong>
          <span v-if="result.heading && result.heading !== result.article_title"> · {{ result.heading }}</span>
          <small>{{ result.snippet }}</small>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
import { createWikiApi } from '@/services/wiki/api.js'
export default {
  name: 'WikiSearch',
  props: { initialQuery: { type: String, default: '' }, syncUrl: { type: Boolean, default: false } },
  data() { return { query: this.initialQuery, results: [], loading: false, error: '', searched: false, timer: null, inputId: `wiki-search-${this._uid}` } },
  mounted() { if (this.query.length >= 2) this.run() },
  beforeDestroy() { clearTimeout(this.timer) },
  methods: {
    schedule() { clearTimeout(this.timer); if (this.syncUrl) this.$router.replace({ query: this.query ? { q: this.query } : {} }); if (this.query.length < 2) { this.results = []; this.searched = false; return } this.timer = setTimeout(this.run, 300) },
    run() {
      if (this.query.length < 2) return
      this.loading = true; this.error = ''
      createWikiApi(this.$http, this.$store.getters.backendurl).search(this.query)
        .then(response => { this.results = response.data || []; this.searched = true })
        .catch(() => { this.error = 'No fue posible realizar la búsqueda.' })
        .finally(() => { this.loading = false })
    },
    resultLink(result) { return { path: `/wiki/${result.article_slug}`, hash: result.anchor ? `#${result.anchor}` : '' } },
  },
}
</script>
